/**
 * Centralized Lazy Loading Service
 * Manages all code-splitting and lazy loading logic
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('lazyLoadSvc', lazyLoadSvc);

    lazyLoadSvc.$inject = [];

    function lazyLoadSvc() {
        var version = window.appVersion || '1.0.0';

        // Bundle configuration - centralized!
        var bundles = {
            // Blog module
            blog: {
                css: [
                    '/assets/css/main.blog.min.css?v=' + version
                ],
                js: [
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/main.blog.min.js?v=' + version
                ]
            },

            // Blog editor (heavier - separate bundle)
            blogEditor: {
                css: [
                    '/assets/css/main.blog.min.css?v=' + version,
                    '/assets/css/vendor.summernote.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.summernote.min.js?v=' + version,
                    '/assets/js/vendor.upload.min.js?v=' + version,
                    '/assets/js/main.blog.min.js?v=' + version
                ]
            },

            // Blog detail (blog + content CSS for richer layout)
            blogDetail: {
                css: [
                    '/assets/css/main.content.min.css?v=' + version,
                    '/assets/css/main.blog.min.css?v=' + version
                ],
                js: [
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/main.blog.min.js?v=' + version
                ]
            },

            // Admin module
            admin: {
                css: [
                    "/assets/css/vendor.summernote.min.css?v=" + version,
                    "/assets/css/vendor.rzslider.min.css?v=" + version,
                    "/assets/css/vendor.payment.min.css?" + version,
                    "/assets/css/main.payment.min.css?" + version,
                    "/assets/css/main.admin.min.css?" + version,
                    "/assets/css/main.profile.min.css?" + version
                ],
                js: [
                    "/assets/js/vendor.phone.min.js?v=" + version,  // Phone validation
                    "/assets/js/vendor.datepicker.min.js?v=" + version,  // Date range picker (for filters)
                    "/assets/js/vendor.gantt.min.js?v=" + version,  // Gantt chart library (from frappe-gantt)
                    "/assets/js/vendor.summernote.min.js?v=" + version,
                    "/assets/js/vendor.rzslider.min.js?v=" + version,
                    "/assets/js/vendor.result.min.js?v=" + version,
                    "/assets/js/vendor.payment.min.js?v=" + version,
                    "/assets/js/vendor.upload.min.js?v=" + version,
                    "/assets/js/main.payment.min.js?v=" + version,
                    "/assets/js/vendor.chart.min.js?v=" + version,
                    "/assets/js/main.admin.min.js?v=" + version
                ],
            },

            // Valuation module (residential, commercial, field, land)
            valuation: {
                css: [
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/vendor.valuation.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.valuation.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.valuation.min.js?v=' + version,
                    "/assets/js/vendor.datepicker.min.js?v=" + version,  // Date range picker (for filters)
                    '/assets/js/main.valuation.min.js?v=' + version,

                ]
            },

            // Commercial valuation (needs turf.js for polygon calculations)
            valuationCommercial: {
                css: [
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/vendor.valuation.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.valuation.min.css?v=' + version
                ],
                js: [
                    '/assets/js/turf.min.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    "/assets/js/vendor.datepicker.min.js?v=" + version,  // Date range picker (for filters)
                    '/assets/js/vendor.valuation.min.js?v=' + version,
                    '/assets/js/main.valuation.min.js?v=' + version
                ]
            },

            // Valuation wrapper (simplified valuation selector)
            valuationWrapper: {
                css: [
                    '/assets/css/vendor.valuation.min.css?v=' + version,
                    '/assets/css/main.valuation.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.valuation.min.js?v=' + version,
                    '/assets/js/main.wrap.min.js?v=' + version
                ]
            },

            // Regional analysis - Main layout (loaded by abstract state)
            regionalAnalysis: {
                css: [
                    '/assets/css/introjs.min.css?v=' + version,
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/vendor.analysis.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.region.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.scroll.min.js?v=' + version,  // Smooth scroll (du-smooth-scroll directive)
                    '/assets/js/vendor.datepicker.min.js?v=' + version,  // Date filters on value tab
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.intro.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.region.min.js?v=' + version,
                    '/assets/js/vendor.analysis.min.js?v=' + version,
                    '/assets/js/polylabel.js?v=' + version
                ]
            },

            // Regional analysis - Wizard (for alarm/notification setup)
            regionalAnalysisMember: {
                css: ["/assets/css/vendor.rzslider.min.css?v=" + version],
                js: [
                    "/assets/js/vendor.rzslider.min.js?v=" + version,
                    '/assets/js/vendor.wizard.min.js?v=' + version,
                    '/assets/js/vendor.phone.min.js?v=' + version
                ]
            },

            // Regional analysis + turf.js (for premium+ users)
            regionalAnalysisPremium: {
                css: [],
                js: [
                    '/assets/js/turf.min.js?v=' + version
                ]
            },

            // Regional analysis + advanced features (for platinum/real-estate users)
            regionalAnalysisPlatinum: {
                css: [
                    '/assets/css/vendor.analysis2.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.analysis2.min.js?v=' + version
                ]
            },
            // Regional analysis - Charts only (for child routes)
            regionalAnalysisCharts: {
                css: [],
                js: [
                    '/assets/js/vendor.chart.min.js?v=' + version
                ]
            },



            // Regional analysis - Listings (opportunity pages)
            regionalAnalysisListings: {
                css: [
                    '/assets/css/main.listing.min.css?v=' + version
                ],
                js: [
                    '/assets/js/simplify.min.js?v=' + version
                ]
            },

            // Regional analysis - Competition/Locations (premium feature)
            regionalAnalysisCompetition: {
                css: [],
                js: [
                    '/assets/js/vendor.analysis3.min.js?v=' + version
                ]
            },

            // Regional analysis - Transportation (needs Google Maps)
            regionalAnalysisTransport: {
                css: [],
                js: function () {
                    var lang = window.lang || 'en';
                    return [
                        'js!https://maps.googleapis.com/maps/api/js?key=AIzaSyA1R2wFiWEsC5N0D_gHwm8l0qOMf4NWvgY&libraries=places&language=' + lang.split('-')[0]
                    ];
                }
            },

            // Leaflet maps
            leaflet: {
                css: [
                    '/assets/css/vendor.leaflet.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.leaflet.min.js?v=' + version
                ]
            },

            // Payment module
            payment: {
                css: [
                    '/assets/css/vendor.payment.min.css?v=' + version,
                    '/assets/css/main.payment.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.payment.min.js?v=' + version,
                    '/assets/js/main.payment.min.js?v=' + version
                ],
            },

            // Payment with external auth (Apple ID)
            paymentExternal: {
                css: [
                    '/assets/css/vendor.payment.min.css?v=' + version,
                    '/assets/css/main.payment.min.css?v=' + version
                ],
                js: [
                    'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
                    '/assets/js/vendor.payment.min.js?v=' + version,
                    '/assets/js/main.payment.min.js?v=' + version
                ]
            },

            // Sales/Order payment (payment + admin components)
            salesPayment: {
                css: [
                    '/assets/css/vendor.payment.min.css?v=' + version,
                    '/assets/css/main.payment.min.css?v=' + version,
                    '/assets/css/main.admin.min.css?v=' + version,
                    '/assets/css/main.profile.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.payment.min.js?v=' + version,
                    '/assets/js/main.payment.min.js?v=' + version,
                    '/assets/js/main.admin.min.js?v=' + version
                ]
            },

            // Profile module
            profile: {
                css: [
                    '/assets/css/vendor.summernote.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.profile.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.datepicker.min.js?v=' + version,  // Date filters on value tab
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone validation
                    '/assets/js/vendor.summernote.min.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.upload.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.profile.min.js?v=' + version,
                    '/assets/js/main.security.min.js?v=' + version
                ],
            },

            // Profile billing (needs payment libs)
            profileBilling: {
                css: [
                    '/assets/css/vendor.payment.min.css?v=' + version,
                    '/assets/css/main.payment.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.payment.min.js?v=' + version
                ]
            },

            // Profile company (needs results lib)
            profileCompany: {
                css: [],
                js: [
                    '/assets/js/vendor.result.min.js?v=' + version
                ]
            },

            // Landing page (homepage with maps and charts)
            landing: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.content.min.css?v=' + version,
                    '/assets/css/main.content.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.content.min.js?v=' + version,
                    '/assets/js/main.content-landing.min.js?v=' + version
                ]
            },
            // Security module (auth pages)
            security: {
                css: [],
                js: [
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone validation (register page)
                    '/assets/js/main.security.min.js?v=' + version
                ],
                serie: true
            },

            // Security with external auth (Apple ID, Google, etc.)
            securityExternal: {
                css: [],
                js: [
                    'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
                    '/assets/js/main.security.min.js?v=' + version,
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone formatting
                ]
            },

            // Content pages (about, contact, how, etc.)
            contentPages: {
                css: [
                    '/assets/css/vendor.content.min.css?v=' + version,
                    '/assets/css/main.content.min.css?v=' + version
                ],
                js: [
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.content.min.js?v=' + version,
                    '/assets/js/main.content.min.js?v=' + version,
                    '/assets/js/main.content-about.min.js?v=' + version
                ]
            },

            // Legal pages (terms, privacy, etc.)
            legalPages: {
                css: [
                    '/assets/css/main.content.min.css?v=' + version
                ],
                js: [
                    '/assets/js/main.content.min.js?v=' + version
                ]
            },

            // Services pages (with charts and content)
            servicesPages: {
                css: [
                    '/assets/css/vendor.content.min.css?v=' + version,
                    '/assets/css/main.content.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.phone.min.js?v=' + version,
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.content.min.js?v=' + version,
                    '/assets/js/main.content.min.js?v=' + version,
                    '/assets/js/main.content-services.min.js?v=' + version
                ]
            },

            // Products pages
            productsPages: {
                css: [
                    '/assets/css/vendor.content.min.css?v=' + version,
                    '/assets/css/main.content.min.css?v=' + version
                ],
                js: [
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.content.min.js?v=' + version,
                    '/assets/js/main.content.min.js?v=' + version,
                    '/assets/js/main.content-products.min.js?v=' + version
                ]
            },

            // Solutions pages (with charts and maps)
            solutionsPages: {
                css: [
                    '/assets/css/vendor.content.min.css?v=' + version,
                    '/assets/css/main.content.min.css?v=' + version,
                    '/assets/css/vendor.chart.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.scroll.min.js?v=' + version,  // Smooth scroll (du-smooth-scroll directive)
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/vendor.content.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.content.min.js?v=' + version,
                    '/assets/js/main.content-users.min.js?v=' + version
                ]
            },

            // Services region page (needs maps)
            servicesRegion: {
                css: [
                    '/assets/css/vendor.map.min.css?v=' + version
                ],
                js: [
                    '/assets/js/polylabel.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version
                ]
            },

            // Property detail page
            property: {
                css: [
                    '/assets/css/main.content.min.css?v=' + version,
                    '/assets/css/main.listing.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone formatting
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/main.property.min.js?v=' + version
                ]
            },

            // Agent detail page (with maps and charts)
            agents: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.region.min.css?v=' + version,
                    '/assets/css/main.agents.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone formatting
                    '/assets/js/vendor.scroll.min.js?v=' + version,  // Smooth scroll (du-smooth-scroll)
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/polylabel.js?v=' + version,
                    '/assets/js/simplify.min.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.wizard.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.agents.min.js?v=' + version
                ]
            },

            // Bank integration page
            bank: {
                css: [],
                js: [
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/main.bank.min.js?v=' + version
                ]
            },

            // Geocoding/Address validation
            geocoding: {
                css: [
                    '/assets/css/main.valuation.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.upload.min.js?v=' + version,
                    '/assets/js/main.geocoding.min.js?v=' + version
                ]
            },

            // Lead/History page (similar to agents)
            leadHistory: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.region.min.css?v=' + version
                ],
                js: [
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/polylabel.js?v=' + version,
                    '/assets/js/simplify.min.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.wizard.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.history.min.js?v=' + version
                ]
            },

            // Projects detail page
            projects: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.projects.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.scroll.min.js?v=' + version,  // Smooth scroll (du-smooth-scroll)
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.projects.min.js?v=' + version
                ]
            },

            // Malls detail page
            malls: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.projects.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.scroll.min.js?v=' + version,  // Smooth scroll (du-smooth-scroll)
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.malls.min.js?v=' + version
                ]
            },

            // Local information/properties (listing)
            localInfo: {
                css: [
                    '/assets/css/main.listing.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone formatting
                    '/assets/js/polylabel.js?v=' + version,
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/simplify.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.listing.min.js?v=' + version
                ]
            },

            // Neighbourhood detail page
            neighbourhood: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.neighbourhood.min.css?v=' + version
                ],
                js: [
                    '/assets/js/polylabel.js?v=' + version,
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/turf.min.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.neighbourhood.min.js?v=' + version
                ]
            },

            // Report verification page
            report: {
                css: [],
                js: [
                    '/assets/js/main.report.min.js?v=' + version
                ]
            },

            // Opportunity/listing pages
            opportunity: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.result.min.css?v=' + version,
                    '/assets/css/main.listing.min.css?v=' + version
                ],
                js: [
                    '/assets/js/turf.min.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/vendor.result.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.result.min.js?v=' + version
                ]
            },

            // Share portfolio page
            share: {
                css: [
                    '/assets/css/main.region.min.css?v=' + version
                ],
                js: [
                    '/assets/js/main.share.min.js?v=' + version
                ]
            },

            // Property detail (valuation results) - heavy with all features
            propertyDetail: {
                css: [
                    '/assets/css/vendor.chart.min.css?v=' + version,
                    '/assets/css/vendor.summernote.min.css?v=' + version,
                    '/assets/css/vendor.result.min.css?v=' + version,
                    '/assets/css/introjs.min.css?v=' + version,
                    '/assets/css/vendor.map.min.css?v=' + version,
                    '/assets/css/main.map.min.css?v=' + version,
                    '/assets/css/main.result.min.css?v=' + version
                ],
                js: [
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone formatting
                    '/assets/js/vendor.datepicker.min.js?v=' + version,  // Date filters
                    '/assets/js/tiny-slider.js?v=' + version,
                    '/assets/js/vendor.summernote.min.js?v=' + version,
                    '/assets/js/vendor.map.min.js?v=' + version,
                    '/assets/js/vendor.chart.min.js?v=' + version,
                    '/assets/js/vendor.intro.min.js?v=' + version,
                    '/assets/js/vendor.result.min.js?v=' + version,
                    '/assets/js/vendor.wizard.min.js?v=' + version,
                    '/assets/js/main.map.min.js?v=' + version,
                    '/assets/js/main.result.min.js?v=' + version
                ]
            },

            // Mortgage application
            mortgage: {
                css: [],
                js: [
                    'https://www.google.com/recaptcha/api.js?render=6LdqE04cAAAAADAoSM5v54W0wLw6XRQvnaU9tgVS',
                    '/assets/js/main.mortgage.min.js?v=' + version
                ]
            },

            //Analyse Comparables
            analyseComparables: {
                css: [],
                js: [
                    '/assets/js/vendor.phone.min.js?v=' + version,  // Phone formatting
                ]
            }
        };

        // Service API
        var service = {
            load: load,
            loadBundle: loadBundle,
            loadBundles: loadBundles,
            preload: preload
        };

        return service;

        ////////////////

        /**
         * Main lazy load function - use in route resolves
         * @param {object} $transition$ - UI Router transition
         * @param {string|array} bundleNames - Bundle name(s) to load
         * @param {object} options - Additional options
         */
        function load($transition$, bundleNames, options) {
            var $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
            var $q = $transition$.injector().get('$q');

            options = options || {};

            // Ensure ngAnimate is available if needed
            if (options.animate !== false) {
                try {
                    $transition$.injector().get('$$animateJs');
                    $ocLazyLoad.inject('ngAnimate');
                } catch (e) {
                    // ngAnimate not needed or already loaded
                }
            }

            // Convert single bundle to array
            if (typeof bundleNames === 'string') {
                bundleNames = [bundleNames];
            }

            // Load all bundles
            var promises = bundleNames.map(function (bundleName) {
                return loadBundleInternal($ocLazyLoad, bundleName, options);
            });

            return $q.all(promises);
        }

        /**
         * Load a single bundle
         */
        function loadBundle($ocLazyLoad, bundleName, options) {
            return loadBundleInternal($ocLazyLoad, bundleName, options);
        }

        /**
         * Load multiple bundles
         */
        function loadBundles($ocLazyLoad, bundleNames, options) {
            var $q = angular.injector(['ng']).get('$q');
            var promises = bundleNames.map(function (name) {
                return loadBundleInternal($ocLazyLoad, name, options);
            });
            return $q.all(promises);
        }

        /**
         * Preload bundles in the background (low priority)
         */
        function preload(bundleNames) {
            if (!window.requestIdleCallback) {
                return; // Browser doesn't support, skip preloading
            }

            window.requestIdleCallback(function () {
                bundleNames.forEach(function (bundleName) {
                    var bundle = bundles[bundleName];
                    if (!bundle) return;

                    // Preload CSS
                    var css = typeof bundle.css === 'function' ? bundle.css() : bundle.css;
                    css.forEach(function (href) {
                        var link = document.createElement('link');
                        link.rel = 'preload';
                        link.as = 'style';
                        link.href = href;
                        document.head.appendChild(link);
                    });

                    // Preload JS
                    var js = typeof bundle.js === 'function' ? bundle.js() : bundle.js;
                    js.forEach(function (src) {
                        if (src.startsWith('js!')) {
                            src = src.substring(3);
                        }
                        var link = document.createElement('link');
                        link.rel = 'preload';
                        link.as = 'script';
                        link.href = src;
                        document.head.appendChild(link);
                    });
                });
            });
        }

        /**
         * Internal bundle loader
         */
        function loadBundleInternal($ocLazyLoad, bundleName, options) {
            options = options || {};
            var bundle = bundles[bundleName];

            if (!bundle) {
                console.warn('Bundle not found:', bundleName);
                return $ocLazyLoad.load([]); // Return resolved promise
            }

            var css = typeof bundle.css === 'function' ? bundle.css() : bundle.css;
            var js = typeof bundle.js === 'function' ? bundle.js() : bundle.js;

            // Load CSS first (non-blocking)
            if (css && css.length) {
                $ocLazyLoad.load(css);
            }

            // Load JS (blocking)
            if (js && js.length) {
                return $ocLazyLoad.load({
                    serie: options.serie !== undefined ? options.serie : false,
                    files: js,
                    insertBefore: options.insertBefore || '#last_script',
                    cache: options.cache !== undefined ? options.cache : true
                });
            }

            // No JS to load, return resolved promise
            return $ocLazyLoad.load([]);
        }
    }
})();
